<template>
  <div id="app">
    <MyMenu />
      <transition name="component-fade" mode="out-in">
        <router-view/>
      </transition>
    <MyFooter />
  </div>
</template>

<script>
import MyMenu from '@/components/MyMenu.vue';
import MyFooter from '@/components/MyBottom.vue';
import store from './store';

export default {
  components: {
    MyMenu,
    MyFooter,
  },
  created() {
    store.dispatch('getProducts');
  },
};
</script>

<style lang="scss">
  @import './assets/theme.scss';
</style>

<style>
  body {
    padding-top: 54px;
    min-height: 100vh;
    position: relative;
    padding-bottom: 120px;
    font-family: 'Roboto Slab', serif;
  }

  @media (min-width: 992px) {
    body {
      padding-top: 56px;
    }
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to {
    opacity: 0;
  }
</style>
